<template>
    <!-- <div
		:style="{ backgroundColor: backgroundColor }"
		class="rp-messenger-header__start"> -->
		<div v-if="!showLoader" class="rp-messenger-header__start-content" :style="{ animationDelay: animationDelay }">
			<div class="rp-helpcenter-header" v-if="(brandIcon && brandIcon!=='NA' && !brandIconError) || (websiteUrl && isItFullScreen)">
				<img
					v-if="brandIcon && brandIcon!=='NA' && !brandIconError"
					:src="brandIconURL"
					class="messenger-brand-icon"
					@error="brandIconError = true"
				>
				<a v-if="websiteUrl && isItFullScreen" :href="websiteUrl" target="_blank" class="rp-brand-url"> 
					<svg width="14" height="14" viewBox="0 0 14 14" xmlns="http://www.w3.org/2000/svg">
					<g stroke="#FFF" fill="none" fill-rule="evenodd" stroke-linecap="round" stroke-linejoin="round"><path d="M11.5 6.73v6.77H.5v-11h7.615M4.5 9.5l7-7M13.5 5.5v-5h-5"></path></g></svg>
					<span class="label"> {{  $t('homeScreen.goto') +' '+ brandName }} </span>
				</a>
			</div>
			<h1
				class="rp-messenger-header__start-title "
				:style="{ fontSize: fontSize, opacity }"	
			>
				<span v-html="truncatedGreeting"></span>
			</h1>
			<p
				class="rp-messenger-header__start-message"
				:style="{ opacity }"
			>
				{{ intro }}
			</p>
			
			
		</div>
    <!-- </div> -->
</template>

<script>
import { COMMAN_IMG_URL, truncate } from '../constants';
// Empirical Data
const MIN_FONT_SIZE = 20;
const MAX_FONT_SIZE = 40;

const BEST_LENGTH = 13;
const TRUNCATE_AT = 30;

export default {

	props: {

		backgroundColor: {
			type: String,
			required: true
		},

		animationDelay: {
			type: String,
			required: true,
		},

		changeAninamtion : {
			required: true
		},

		greeting: {
			type: String,
			required: true
		},

		intro: {
			type: String,
			required: true
		},

		showLoader: {
			type: Boolean,
			required: true,
		},

		brandIcon: {
			type: String,
			required: false,
		},

		opacity: {
			type: Number,
			required: true
		},

		isItFullScreen: Boolean,

		websiteUrl: {
			type: String
		},

		brandName: {
			type: String
		}

	},
	mounted() {
		const introHeight = document.querySelector('.rp-messenger-header__start-content')
		if(introHeight)
			this.$emit('setHeight', {height: introHeight.clientHeight})
	},
	computed: {

		fontSize() {
			const length = this.greeting.length;

			const size = () => {
				if (length <= BEST_LENGTH) {
					return MAX_FONT_SIZE;
				} else if (length > BEST_LENGTH && length < TRUNCATE_AT) {
					return (MAX_FONT_SIZE / length)*BEST_LENGTH;
				} else {
					return MIN_FONT_SIZE;
				}
			}

			return size() + 'px';
		},

		truncatedGreeting() {
			return truncate(this.greeting, {
				length: TRUNCATE_AT
			});
		},

		brandIconURL() {
			return COMMAN_IMG_URL + this.brandIcon;
		}

	},
	data() {
		return {
			brandIconError: false,
		}
	}
	
}

</script>


<style lang="scss">
.rp-messenger-header__start {
	//flex-basis: 40%;
	height: 250px;
	background: none;
	display: flex;
	align-items: center;
	justify-content: flex-start;
	flex-direction: column;
	text-align: center;
	position: relative;
	// transition: height 0.01s ease-out;
	// position: fixed;
	&.small-header {
		height: 75px;
		// transition: height 0.01s ease-in;
		border-radius: 0px !important;
	}
}

.rp-messenger-header__start-content {
	z-index: 1;
	width: 100%;
	overflow: hidden;
	text-align: left;
	padding: 26px 40px 10px 40px;
	// opacity: 0;
	.rp-helpcenter-header {
		min-height: 30px;
		.messenger-brand-icon{
			width: auto;
			height: 40px;
			max-width: 95%;
			object-fit: contain;
		}
	}
	&.fullscreen {
		.rp-brand-url {
			float: right;
    		display: flex;
			align-items: center;	
			&:hover {
				opacity: 0.8;
			}
			.label {
				font-size: 14px;
				font-weight: 600;
				color: #fff;
				padding-left: 8px;
			}
		}
		padding: 26px 40px 10px 40px;
		@include for-size(tablet-landscape-up){
			margin: 0px 16px;
			padding: 30px 40px 10px;
		}
		@include for-size(desktop-up){
			margin: 0px 16px;
			padding: 30px 60px 10px;
		}
		.rp-messenger-header__start-message {
			max-width: unset;
			font-size: 20px;
			@media screen and (max-width: 600px) {
				font-size: 16px;
			}
		}
	}
}

.rp-messenger-header__start-title {
	font-weight: 500;
	font-size: 40px;
	margin: 0;
	animation-duration: .5s;
	white-space: nowrap;
	overflow: hidden;
	max-width: 300px;
	text-overflow: ellipsis;
	color: #fff;
	@media only screen 
	and (min-device-width: 320px) 
	and (max-device-width: 480px) {
		max-width: 225px;
	}
}

.rp-messenger-header__start-message {
	max-width: 300px;
	max-height: 65px;
	overflow: hidden;
	margin: .3rem auto;
	font-weight: 200;
	font-size: 16px;
	line-height: 1.4;
	animation-duration: .75s;
	overflow-wrap: break-word;
  	word-wrap: break-word;
	word-break: break-word;
	font-weight: 400;
	opacity: 1;
	text-align: left;
	margin-left: 0px;
	color: rgba(255,255,255,0.9);
	font-weight: 400;
}
.order-list-main-header {
	font-size: 20px;
    font-weight: 500;
    color: #ffffff;
}

.order-list-title {
font-size: 20px;
    font-weight: bold;
}

</style>